// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"169":"805239c4","436":"579f84a4"}[chunkId] + ".chunk.css";
};